<template>
  <div class="grid">
    <div v-if="data.Company">
      <label>{{ __("Name") }}</label>
      <span>{{ data.Company }}</span>
    </div>
    <div v-if="data.FirstName || data.LastName">
      <label>{{ __("Contact") }}</label>
      <span>{{ data.FirstName }} {{ data.LastName }}</span>
    </div>
    <div v-if="data.TelMobile">
      <label>{{ __("Phone") }}</label>
      <a :href="`tel:${data.TelMobile}`">{{
        data.TelMobile
      }}</a>
    </div>
  </div>
  <div v-if="data.Email">
    <label>{{ __("Miles") }}</label>
    <a :href="`mailto:${data.Email}`">{{ data.Email }}</a>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },
};
</script>

<style scoped>

</style>
